import { INPUT_TYPES } from '@/modules/CourseManagement/constants';
import FileInput from '@/components/InputFields/FileInput.vue';
import HintWrap from '@/components/HintWrap.vue';
import MaskaField from '@/components/InputFields/MaskaField.vue';

const userInfoFieldsAlias = ['surname', 'name', 'patronymic'];

const sortAttrs = [...userInfoFieldsAlias, 'sex', 'diploma_surname', 'national', 'birth_date', 'job', 'job_post', 'education_level', 'document_series', 'document_number', 'snils'];

const fieldAlias = {
  snilsField: (i) => ({
    text: `${i.name} ${i.is_required ? '*' : ''}`,
    value: i.id.toString(),
    rules: i.is_required ? 'required|length:14|snils' : 'length:14|snils',
    component: HintWrap,
    component_attrs: {
      component: MaskaField,
      type: 'snils',
      returnMasked: true,
      hintDescription: i.description,
      rounded: true,
      filled: true,
    },
  }),
};

const fieldTypes = {
  [INPUT_TYPES.number]: (i) => ({
    text: `${i.name} ${i.is_required ? '*' : ''}`,
    value: i.id.toString(),
    rules: i.is_required ? 'required' : 'required',
    component: HintWrap,
    component_attrs: {
      component: 'v-text-field',
      hintDescription: i.description,
      rounded: true,
      filled: true,
      type: 'number',
    },
  }),
  [INPUT_TYPES.text]: (i) => ({
    text: `${i.name} ${i.is_required ? '*' : ''}`,
    value: i.id.toString(),
    rules: i.is_required ? 'required' : 'required',
    component: HintWrap,
    component_attrs: {
      component: 'v-text-field',
      hintDescription: i.description,
      rounded: true,
      filled: true,
    },
  }),
  [INPUT_TYPES.file]: (i) => ({
    text: `${i.name} ${i.is_required ? '*' : ''}`,
    value: i.id.toString(),
    rules: i.is_required ? 'required' : '',
    component: HintWrap,
    component_attrs: {
      component: FileInput,
      rounded: true,
      filled: true,
    },
  }),
  [INPUT_TYPES.list]: (i) => ({
    text: `${i.name} ${i.is_required ? '*' : ''}`,
    value: i.id.toString(),
    rules: i.is_required ? 'required' : '',
    component: HintWrap,
    component_attrs: {
      component: 'v-select',
      hintDescription: i.description,
      items: i.value_options,
      rounded: true,
      filled: true,
    },
  }),
  [INPUT_TYPES.calendar]: (i) => ({
    text: `${i.name} ${i.is_required ? '*' : ''}`,
    value: i.id.toString(),
    rules: i.is_required ? 'required' : '',
    component: 'sdo-datetime-field',
    component_attrs: {
      'only-date': true,
      'label-date': i.name,
    },
  }),
};

export const getField = (field) => ({
  ...Object.keys(fieldAlias).includes(field.alias)
    ? fieldAlias[field.type](field)
    : fieldTypes[field.type](field),
});

export const getSortedFields = (fields) => {
  const sorted = [...fields].reduce((acc, attr) => {
    const sortIndex = sortAttrs.indexOf(attr.alias);
    if (sortIndex === -1) acc[1].push(attr);
    else acc[0][sortIndex] = attr;
    return acc;
  }, [[], []]).flat();
  return sorted.map(getField);
};

export default {
  getField,
  getSortedFields,
  fieldTypes,
  fieldAlias,
};
